import {
    getCharMinMessage,
    getSelectMessage
} from '../../../utils/formValidation/errorMessageFunctions';

export const NOTE_MIN_CHAR = 5;
export const NOTE_MAX_CHAR = 750;

export const validate = (newEntry) => {
    let newErrors = {};

    if (!newEntry.actionStatusId) {
        newErrors = {
            ...newErrors,
            actionStatusId: { error: true, message: getSelectMessage('action status', 'an') }
        };
    }

    if (newEntry.actionNotes.trim().length < NOTE_MIN_CHAR) {
        newErrors = {
            ...newErrors,
            actionNotes: { error: true, message: getCharMinMessage('Notes', NOTE_MIN_CHAR) }
        };
    }

    return newErrors;
};
